"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evlrHeaderLength = exports.vlrHeaderLength = exports.minHeaderLength = void 0;
exports.minHeaderLength = 375;
exports.vlrHeaderLength = 54;
exports.evlrHeaderLength = 60;
